var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionJoinGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#FF7A00"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.667 10V8.667h-1.334V10H16v1.333h1.333v1.334h1.334v-1.334H20V10h-1.333ZM9.333 12a2.666 2.666 0 1 0 .002-5.332A2.666 2.666 0 0 0 9.333 12Zm0-4c.734 0 1.334.6 1.334 1.333 0 .734-.6 1.334-1.334 1.334-.733 0-1.333-.6-1.333-1.334C8 8.6 8.6 8 9.333 8ZM9.333 12.667c-1.78 0-5.333.893-5.333 2.666v2h10.667v-2c0-1.773-3.554-2.666-5.334-2.666Zm4 3.333h-8v-.66c.134-.48 2.2-1.34 4-1.34 1.8 0 3.867.86 4 1.333V16ZM12.34 6.7a4.01 4.01 0 0 1 .993 2.634c0 1.006-.38 1.926-.993 2.633a2.658 2.658 0 0 0 2.327-2.633c0-1.36-1.02-2.467-2.327-2.634ZM15.02 13.22c.593.553.98 1.247.98 2.113v2h1.333v-2c0-.966-1.06-1.673-2.313-2.113Z",
  fill: "#fff"
})));
export { SvgActionJoinGroup as ReactComponent };
export default __webpack_public_path__ + "images/action-join-group.svg";